module.exports = __webpack_public_path__ + "img/logo9.6e4d9e43.png";